import { DateFormats, formatDate, formatPhoneNumber } from '@strata/helper-functions';
import { FormSectionWithRows } from '@strata/react-form-section';
import { DetailLabel, DetailLabelValuePair } from '@strata/react-label-value-pairs';
import { IssueDetail } from '@strata/react-status-icons';
import PropTypes from 'prop-types';

import { LabelWithIssue } from 'components/opportunities/LabelWithIssue';
import { FaxStatusIndicator } from 'components/shared/FaxStatusIndicator';

export const OpportunityPrescriberDetails = ({
    prescriberDetails = undefined,
    prescriberFaxPref = undefined,
    referralFaxStatus = undefined,
    opportunityIssues = undefined,
    isLoading = true,
}) => (
    <FormSectionWithRows
        sectionTitle="Prescriber Details"
        width="100%"
        isLoading={isLoading}
        rowOneContent={
            <>
                <DetailLabelValuePair
                    style={{ width: '33%' }}
                    label="Name"
                    value={prescriberDetails?.prescriberName || 'Missing Prescriber'}
                />
                <DetailLabelValuePair
                    style={{ width: '33%' }}
                    label={
                        <LabelWithIssue
                            text="Prescriber NPI"
                            issues={opportunityIssues}
                            issueType={IssueDetail.IssueTypes.INVALID_PRESCRIBER_NPI}
                        />
                    }
                    value={prescriberDetails?.prescriberNpi}
                />
                <DetailLabelValuePair
                    style={{ width: '34%' }}
                    label="Phone"
                    value={formatPhoneNumber(prescriberDetails?.prescriberPhone)}
                />
            </>
        }
        rowTwoContent={
            <>
                <DetailLabelValuePair
                    style={{ width: '33%' }}
                    label="Fax"
                    value={formatPhoneNumber(prescriberDetails?.prescriberFax)}
                />
                <DetailLabelValuePair
                    style={{ width: '33%' }}
                    label="Point of Contact"
                    value={prescriberDetails?.pointOfContactName}
                />
                <DetailLabelValuePair
                    style={{ width: '34%' }}
                    label="Point of Contact Phone"
                    value={formatPhoneNumber(prescriberDetails?.pointOfContactPhone)}
                />
            </>
        }
        rowThreeContent={
            <>
                <DetailLabelValuePair
                    style={{ width: '33%' }}
                    label="Practice"
                    value={prescriberDetails?.practice}
                />
                <DetailLabelValuePair
                    style={{ width: '33%' }}
                    label="Practice NPI"
                    value={prescriberDetails?.practiceNpi}
                />
                <div style={{ width: '34%' }}>
                    <DetailLabel label="Last Fax Status" />
                    <FaxStatusIndicator
                        canSendFax={!!prescriberDetails?.prescriberFax}
                        faxPrefOptionValue={prescriberFaxPref?.option_value}
                        faxStatus={referralFaxStatus?.prescriber}
                    />
                </div>
            </>
        }
        rowFourContent={
            <DetailLabelValuePair
                style={{ width: '33%' }}
                label="Last Fax Sent"
                value={formatDate(referralFaxStatus?.prescriber?.date_sent, DateFormats.DATE_TIME)}
            />
        }
    />
);
OpportunityPrescriberDetails.propTypes = {
    prescriberDetails: PropTypes.shape({
        prescriberName: PropTypes.string,
        prescriberPhone: PropTypes.string,
        prescriberFax: PropTypes.string,
        pointOfContactName: PropTypes.string,
        pointOfContactPhone: PropTypes.string,
        prescriberNpi: PropTypes.string,
        practice: PropTypes.string,
        practiceNpi: PropTypes.string,
        address1: PropTypes.string,
        address2: PropTypes.string,
        city: PropTypes.string,
        state: PropTypes.string,
        zip: PropTypes.string,
    }),
    isLoading: PropTypes.bool,
    prescriberFaxPref: PropTypes.shape({
        option_value: PropTypes.string.isRequired,
    }),
    referralFaxStatus: PropTypes.shape({
        prescriber: PropTypes.shape({
            message: PropTypes.string,
            status: PropTypes.string,
            date_sent: PropTypes.string,
            tooltip: PropTypes.string,
        }),
    }),
    opportunityIssues: PropTypes.arrayOf(PropTypes.string),
};
